<div class="pl-ul flex flex-col gap-4 bg-pl-gray-250 pt-5">
  <h4 class="whitespace-normal break-words px-5 text-pl-gray-450">{{ label | plSlice: 200 }}</h4>
  <div>
    <ng-container *ngIf="minItemsDisplayed > 0">
      <div
        *ngFor="let item of itemsFiltered() | slice: 0 : minItemsDisplayed; let isLast = last"
        class="border-t border-white"
        [class.border-b]="isLast"
      >
        <ng-container [ngTemplateOutlet]="listItem" [ngTemplateOutletContext]="{ item: item }"></ng-container>
      </div>
    </ng-container>
    <mat-expansion-panel
      [(expanded)]="isPanelOpen"
      (opened)="onPanelToggle()"
      (closed)="onPanelToggle()"
      class="rounded-0 !shadow-none"
    >
      <div
        *ngFor="let item of itemsFiltered() | slice: minItemsDisplayed; let isFirst = first; let isLast = last"
        class="border-white"
        [class.border-t]="!isFirst || minItemsDisplayed === 0"
        [class.border-b]="isLast"
      >
        <ng-container [ngTemplateOutlet]="listItem" [ngTemplateOutletContext]="{ item: item }"></ng-container>
      </div>
    </mat-expansion-panel>
  </div>

  <div class="w-full px-5 pb-5" *ngIf="itemsFiltered().length > minItemsDisplayed">
    <pl-button
      [variant]="ButtonVariant.white"
      class="!w-fit"
      [padding]="ButtonPadding.small"
      (click)="toggleExpansionPanel()"
    >
      <pl-icon
        [name]="PlIcon.chevron_forward"
        class="h-8 w-8 transition-all duration-300"
        [ngClass]="isPanelOpen ? '-rotate-90' : 'rotate-90'"
      ></pl-icon>
      <span>{{ buttonLabel() }}</span>
    </pl-button>
  </div>
</div>

<ng-template #listItem let-item="item">
  <div class="flex flex-col gap-4 bg-pl-gray-200 px-5 py-4">
    <p
      class="pl-inner-html font-sans text-lg"
      [ngClass]="{
        'font-bold': !!item.sub_label || !!item.takeaways
      }"
      [innerHTML]="item.label"
    ></p>
    <div
      class="item-sub-label pl-inner-html !whitespace-pre-line font-sans text-lg text-pl-gray-450"
      *ngIf="item.sub_label"
      [innerHTML]="item.sub_label"
    ></div>
    <div *ngIf="!!item.takeaways" class="flex flex-col gap-2">
      <p class="font-sans text-lg font-bold text-pl-blue-500">{{ 'blocks.ul.your_notes' | translate }}</p>
      <p class="pl-inner-html font-sans text-lg font-bold text-pl-blue-500" [innerHTML]="item.takeaways"></p>
    </div>
  </div>
</ng-template>
